module.exports = __webpack_public_path__ + "static/sport/bgi-h5.05c9536.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparker/bgi-h5.jpg
// module id = 9LmY
// module chunks = 0